import { render, staticRenderFns } from "./CouponDiscounts.vue?vue&type=template&id=78fdd29a&scoped=true"
import script from "./CouponDiscounts.vue?vue&type=script&lang=js"
export * from "./CouponDiscounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fdd29a",
  null
  
)

export default component.exports